// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* contentFileUpload.css
   ─────────────────────────────────────────────────────────────────────────────
   Scoped with scl--cms-components-contentFileUpload- prefix.
   All values taken directly from Figma spec.
   ───────────────────────────────────────────────────────────────────────────── */

/* ─── Root container ────────────────────────────────────────────────────────── */
/*
  Figma spec:
    box-sizing: border-box
    display: flex; flex-direction: column; align-items: center
    padding: 24px; gap: 16px
    width: 464px; height: 128px
    background: #FFFFFF
    border: 1px dashed #E5E5E7
    border-radius: 10px
*/
.scl--cms-components-contentFileUpload-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  gap: 26px;

  width: 100%;
  height: 128px;

  background: #FFFFFF;
  border: 1px dashed #E5E5E7;
  border-radius: 10px;

  cursor: pointer;
  user-select: none;
  transition: background 0.15s ease, border-color 0.15s ease;

  /* Figma inside auto layout */
  flex: none;
  order: 2;
  flex-grow: 0;
}

.scl--cms-components-contentFileUpload-container:hover {
  background: #F9FAFB;
  border-color: #C8CBD0;
  cursor: default;
}

.scl--cms-components-contentFileUpload-container--dragging {
  background: #F0F5FF;
  border-color: #2388FF;
}

/* Keyboard focus outline */
.scl--cms-components-contentFileUpload-container:focus-visible {
  outline: 2px solid #2388FF;
  outline-offset: 2px;
}

/* ─── Hidden file input ─────────────────────────────────────────────────────── */
.scl--cms-components-contentFileUpload-input {
  display: none;
}

/* ─── Icon button ───────────────────────────────────────────────────────────── */
/*
  Figma spec:
    display: flex; flex-direction: row; justify-content: center; align-items: center
    padding: 8px
    width: 36px; height: 36px
    background: #FFFFFF
    border: 1px solid #E5E5E7
    box-shadow: 0px 0px 0px 3px #EFF1F3
    border-radius: 128px
*/
.scl--cms-components-contentFileUpload-icon-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;

  width: 36px;
  height: 36px;
  box-sizing: border-box;

  background: #FFFFFF;
  border: 1px solid #E5E5E7;
  box-shadow: 0px 0px 0px 3px #EFF1F3;
  border-radius: 128px;

  /* Figma inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

/* ─── Upload icon (SVG) ─────────────────────────────────────────────────────── */
/*
  Figma spec:
    width: 20px; height: 20px
    position: absolute (within its 36px parent)
    left: 12.5%; right: 12.5%; top: 14.22%; bottom: 12.51%
    border: 1.67px solid #323539
*/
.scl--cms-components-contentFileUpload-icon {
  width: 20px;
  height: 20px;
  flex: none;
  order: 0;
  flex-grow: 0;
  display: block;
}

/* ─── Text area ─────────────────────────────────────────────────────────────── */
/*
  Figma spec:
    display: flex; flex-direction: column; justify-content: flex-end; align-items: center
    padding: 0px; gap: 10px
    width: 416px; height: 28px
    flex: none; order: 1; align-self: stretch; flex-grow: 0
*/
.scl--cms-components-contentFileUpload-text {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  gap: 10px;

  width: 100%;
  height: 28px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}
.scl--cms-components-contentFileUpload-header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;              /* ✅ allow wrapping */
  justify-content: center;
  align-items: center;          /* better for multi-line */
  padding: 0;
  width: 100%;
  height: auto;                 /* ✅ remove fixed height */
  min-height: 18px;             /* match line-height */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;

  text-align: center;           /* center wrapped lines */
}


/* Clickable link text — blue */
.scl--cms-components-contentFileUpload-link {
  color: #2388FF;
  white-space: normal;
}
.scl--cms-components-contentFileUpload-link:hover{
    cursor: pointer;
    text-decoration: underline;
}

/* Plain gray text between links */
.scl--cms-components-contentFileUpload-plain {
  color: #323539;
  white-space: normal;
}

/* ─── Support text ──────────────────────────────────────────────────────────── */
/*
  Figma spec:
    display: flex; flex-direction: row; justify-content: center; align-items: center
    padding: 0px; gap: 4px
    width: 416px; height: 9px
    flex: none; order: 1; align-self: stretch; flex-grow: 0

    Text: font-weight 400, 12px, line-height 18px, color #858C95, text-align center
*/
.scl--cms-components-contentFileUpload-support {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 4px;

  width: 100%;
  height: 9px;

  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #858C95;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

/* ─── Responsive ────────────────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .scl--cms-components-contentFileUpload-container {
    width: 100%;
    height: auto;
    min-height: 128px;
  }

  .scl--cms-components-contentFileUpload-text,
  .scl--cms-components-contentFileUpload-header,
  .scl--cms-components-contentFileUpload-support {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/card-fs-cp/upload-card-op/css/contentFileUpload.css"],"names":[],"mappings":"AAAA;;;;kFAIkF;;AAElF,kFAAkF;AAClF;;;;;;;;;CASC;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;;EAET,WAAW;EACX,aAAa;;EAEb,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;;EAEnB,eAAe;EACf,iBAAiB;EACjB,0DAA0D;;EAE1D,6BAA6B;EAC7B,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,aAAa;AACf;;AAEA,kFAAkF;AAClF;;;;;;;;;CASC;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;;EAEZ,WAAW;EACX,YAAY;EACZ,sBAAsB;;EAEtB,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,oBAAoB;;EAEpB,6BAA6B;EAC7B,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA,kFAAkF;AAClF;;;;;;CAMC;AACD;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA,kFAAkF;AAClF;;;;;;CAMC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,SAAS;;EAET,WAAW;EACX,YAAY;;EAEZ,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe,eAAe,qBAAqB;EACnD,uBAAuB;EACvB,mBAAmB,WAAW,0BAA0B;EACxD,UAAU;EACV,WAAW;EACX,YAAY,kBAAkB,0BAA0B;EACxD,gBAAgB,cAAc,sBAAsB;;EAEpD,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;;EAEZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB,YAAY,yBAAyB;AACzD;;;AAGA,+BAA+B;AAC/B;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;;;;;;;;CAQC;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,QAAQ;;EAER,WAAW;EACX,WAAW;;EAEX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;;EAEd,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA,kFAAkF;AAClF;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;;IAGE,WAAW;EACb;AACF","sourcesContent":["/* contentFileUpload.css\n   ─────────────────────────────────────────────────────────────────────────────\n   Scoped with scl--cms-components-contentFileUpload- prefix.\n   All values taken directly from Figma spec.\n   ───────────────────────────────────────────────────────────────────────────── */\n\n/* ─── Root container ────────────────────────────────────────────────────────── */\n/*\n  Figma spec:\n    box-sizing: border-box\n    display: flex; flex-direction: column; align-items: center\n    padding: 24px; gap: 16px\n    width: 464px; height: 128px\n    background: #FFFFFF\n    border: 1px dashed #E5E5E7\n    border-radius: 10px\n*/\n.scl--cms-components-contentFileUpload-container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 20px;\n  gap: 26px;\n\n  width: 100%;\n  height: 128px;\n\n  background: #FFFFFF;\n  border: 1px dashed #E5E5E7;\n  border-radius: 10px;\n\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  /* Figma inside auto layout */\n  flex: none;\n  order: 2;\n  flex-grow: 0;\n}\n\n.scl--cms-components-contentFileUpload-container:hover {\n  background: #F9FAFB;\n  border-color: #C8CBD0;\n  cursor: default;\n}\n\n.scl--cms-components-contentFileUpload-container--dragging {\n  background: #F0F5FF;\n  border-color: #2388FF;\n}\n\n/* Keyboard focus outline */\n.scl--cms-components-contentFileUpload-container:focus-visible {\n  outline: 2px solid #2388FF;\n  outline-offset: 2px;\n}\n\n/* ─── Hidden file input ─────────────────────────────────────────────────────── */\n.scl--cms-components-contentFileUpload-input {\n  display: none;\n}\n\n/* ─── Icon button ───────────────────────────────────────────────────────────── */\n/*\n  Figma spec:\n    display: flex; flex-direction: row; justify-content: center; align-items: center\n    padding: 8px\n    width: 36px; height: 36px\n    background: #FFFFFF\n    border: 1px solid #E5E5E7\n    box-shadow: 0px 0px 0px 3px #EFF1F3\n    border-radius: 128px\n*/\n.scl--cms-components-contentFileUpload-icon-btn {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n\n  width: 36px;\n  height: 36px;\n  box-sizing: border-box;\n\n  background: #FFFFFF;\n  border: 1px solid #E5E5E7;\n  box-shadow: 0px 0px 0px 3px #EFF1F3;\n  border-radius: 128px;\n\n  /* Figma inside auto layout */\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n/* ─── Upload icon (SVG) ─────────────────────────────────────────────────────── */\n/*\n  Figma spec:\n    width: 20px; height: 20px\n    position: absolute (within its 36px parent)\n    left: 12.5%; right: 12.5%; top: 14.22%; bottom: 12.51%\n    border: 1.67px solid #323539\n*/\n.scl--cms-components-contentFileUpload-icon {\n  width: 20px;\n  height: 20px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  display: block;\n}\n\n/* ─── Text area ─────────────────────────────────────────────────────────────── */\n/*\n  Figma spec:\n    display: flex; flex-direction: column; justify-content: flex-end; align-items: center\n    padding: 0px; gap: 10px\n    width: 416px; height: 28px\n    flex: none; order: 1; align-self: stretch; flex-grow: 0\n*/\n.scl--cms-components-contentFileUpload-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0;\n  gap: 10px;\n\n  width: 100%;\n  height: 28px;\n\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n}\n.scl--cms-components-contentFileUpload-header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;              /* ✅ allow wrapping */\n  justify-content: center;\n  align-items: center;          /* better for multi-line */\n  padding: 0;\n  width: 100%;\n  height: auto;                 /* ✅ remove fixed height */\n  min-height: 18px;             /* match line-height */\n\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n\n  text-align: center;           /* center wrapped lines */\n}\n\n\n/* Clickable link text — blue */\n.scl--cms-components-contentFileUpload-link {\n  color: #2388FF;\n  white-space: normal;\n}\n.scl--cms-components-contentFileUpload-link:hover{\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n/* Plain gray text between links */\n.scl--cms-components-contentFileUpload-plain {\n  color: #323539;\n  white-space: normal;\n}\n\n/* ─── Support text ──────────────────────────────────────────────────────────── */\n/*\n  Figma spec:\n    display: flex; flex-direction: row; justify-content: center; align-items: center\n    padding: 0px; gap: 4px\n    width: 416px; height: 9px\n    flex: none; order: 1; align-self: stretch; flex-grow: 0\n\n    Text: font-weight 400, 12px, line-height 18px, color #858C95, text-align center\n*/\n.scl--cms-components-contentFileUpload-support {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  gap: 4px;\n\n  width: 100%;\n  height: 9px;\n\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: #858C95;\n\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n/* ─── Responsive ────────────────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .scl--cms-components-contentFileUpload-container {\n    width: 100%;\n    height: auto;\n    min-height: 128px;\n  }\n\n  .scl--cms-components-contentFileUpload-text,\n  .scl--cms-components-contentFileUpload-header,\n  .scl--cms-components-contentFileUpload-support {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
